<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div v-show="ui.step === 'acceuil'">
      <p class="ContextBlockSpec">
        L'activité physique est la portée de tous, elle est aussi bénéfique pour tous. Mais de quels bénéfices parle-t-on ?
      </p>

      <p class="ObjectiveBlockSpec">
        <b class="primary--text">Objectif : </b>
        Découvrir les bénéfices d'une activité physique régulière.
      </p>

      <div class="InstructionsBlockSpec">
        Pour réaliser cette mission, vous devez :<br/>
        <ol>
          <li>Consulter notre fiche santé</li>
          <li>Répondre au quiz</li>
          <li>VALIDER la mission</li>
        </ol>
      </div>

      <IriadeFile :file_title="mission.module.config.media.title" :media_url="mission.module.config.media.media_url"></IriadeFile>

      <v-btn block
             large
             rounded
             @click="step('q1')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'q1'">
      <span class="Question">Testez vos connaissances sur les bienfaits d'une activité physique régulière (<span class="primary--text">1</span>/3)</span>
      <br/>
      <br/>
      <!--suppress HtmlDeprecatedAttribute -->
      <p class="Question">L'activité physique réduit de 25% le risque de faire un AVC</p>

      <div v-if="missionData.quiz.question1 === null" style="display: flex; flex: auto; flex-direction: row; justify-content: space-evenly">
        <v-btn rounded
               @click="missionData.quiz.question1 = true"
               class="primary mt-10 mb-4">Vrai
        </v-btn>
        <v-btn rounded
               @click="missionData.quiz.question1 = false"
               class="primary mt-10 mb-4">Faux
        </v-btn>
      </div>

      <div class="Info" v-if="missionData.quiz.question1 === true">
        <b>Bonne réponse ! </b>La pratique régulière d'une activité physique diminue le risque de développer de l'hypertension artérielle, elle diminue de 9 à 29% le risque de faire un infarctus et réduit de 25% le risque d'accident vasculaire cérébral.
      </div>

      <div class="Info" v-if="missionData.quiz.question1 === false">
        <b>Mauvaise réponse ! </b>La pratique régulière d'une activité physique diminue le risque de développer de l'hypertension artérielle, elle diminue de 9 à 29% le risque de faire un infarctus et réduit de 25% le risque d'accident vasculaire cérébral.
      </div>

      <v-btn block
             large
             rounded
             @click="step('q2')"
             class="primary mt-10 mb-4"
             v-if="missionData.quiz.question1 !== null">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q2'">
      <span class="Question">Testez vos connaissances sur les bienfaits d'une activité physique régulière (<span class="primary--text">2</span>/3)</span>
      <br/>
      <br/>
      <!--suppress HtmlDeprecatedAttribute -->
      <p class="Question">La pratique d'une activité physique régulière n'a aucune influence sur le cholestérol (LDL et HDL)</p>

      <div v-if="missionData.quiz.question2 === null" style="display: flex; flex: auto; flex-direction: row; justify-content: space-evenly">
        <v-btn rounded
               @click="missionData.quiz.question2 = false"
               class="primary mt-10 mb-4">Vrai
        </v-btn>
        <v-btn rounded
               @click="missionData.quiz.question2 = true"
               class="primary mt-10 mb-4">Faux
        </v-btn>
      </div>

      <div class="Info" v-if="missionData.quiz.question2 === true">
        <b>Bonne réponse ! </b>La pratique régulière d'une activité physique diminue le mauvais cholestérol (LDL) et augmente le bon (HDL).
      </div>

      <div class="Info" v-if="missionData.quiz.question2 === false">
        <b>Mauvaise réponse ! </b>La pratique régulière d'une activité physique diminue le mauvais cholestérol (LDL) et augmente le bon (HDL).
      </div>

      <v-btn block
             large
             rounded
             @click="step('q3')"
             class="primary mt-10 mb-4"
             v-if="missionData.quiz.question2 !== null">Suite
      </v-btn>
    </div>

    <div v-show="ui.step === 'q3'">
      <span class="Question">Testez vos connaissances sur les bienfaits d'une activité physique régulière (<span class="primary--text">3</span>/3)</span>
      <br/>
      <br/>
      <p class="Question">Une activité physique régulière diminue le risque de fractures non traumatiques</p>

      <div v-if="missionData.quiz.question3 === null" style="display: flex; flex: auto; flex-direction: row; justify-content: space-evenly">
        <v-btn rounded
               @click="missionData.quiz.question3 = true"
               class="primary mt-10 mb-4">Vrai
        </v-btn>
        <v-btn rounded
               @click="missionData.quiz.question3 = false"
               class="primary mt-10 mb-4">Faux
        </v-btn>
      </div>

      <div class="Info" v-if="missionData.quiz.question3 === true">
        <b>Bonne réponse ! </b>La pratique régulière d'une activité physique diminue le risque d'ostéoporose et de fracture non traumatiques. Elle diminue aussi les douleurs en cas de lombalgies chroniques.
      </div>

      <div class="Info" v-if="missionData.quiz.question3 === false">
        <b>Mauvaise réponse ! </b>La pratique régulière d'une activité physique diminue le risque d'ostéoporose et de fracture non traumatiques. Elle diminue aussi les douleurs en cas de lombalgies chroniques.
      </div>

      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4"
             v-if="missionData.quiz.question3 !== null">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'fin'">
      <div class="Info">
        Merci d'avoir répondu à ce questionnaire.<br/>
        Vous pourrez retrouver l'analyse de vos réponses dans votre médiathèque.
      </div>

      <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour valider et enregistrer ce questionnaire</p>

      <FinishMissionButtonBlock class="mt-10"
                                @click.native="finishMission">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'
  import IriadeFile from 'components/Iriade/IriadeFile'

  export default {
    components: {
      FinishMissionButtonBlock,
      MissionContainer,
      IriadeFile
    },
    data () {
      return {
        missionData: {
          quiz: {
            question1: null,
            question2: null,
            question3: null
          }
        },
        ui: {
          step: 'acceuil'
        }
      }
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.updateData(target);
        this.ui.step = target;
      },

      updateData(target) {
        switch (target) {

        }
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
